export class ApiSuccessResponse<T = null> {
    public success: boolean = true;
    public data: T;

    constructor(data: T = null as T) {
        this.data = data;
    }
}

export class ApiErrorResponse extends Error {
    public success: boolean = false;
    public message: string;
    public details: string | undefined;
    public code: number | undefined;

    constructor(message: string, details?: string, code?: number) {
        super(message);
        this.message = message;
        this.details = details;
        this.code = code;
    }
}
